import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import activoService from '../../../services/activoService';
import ActivoForm from './ActivoForm';
import Toast from '../../../components/Common/Toast';

const EditActivo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activo, setActivo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    let cancelled = false;
    activoService
      .getActivo(id)
      .then((res) => {
        if (cancelled) return;
        if (res.success) setActivo(res.data);
        else setToast({ isOpen: true, message: res.message || 'Activo no encontrado', type: 'error' });
      })
      .catch(() => {
        if (!cancelled) setToast({ isOpen: true, message: 'Error al cargar el activo', type: 'error' });
      })
      .finally(() => {
        if (!cancelled) setPageLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await activoService.updateActivo(id, data);
      if (response.success) {
        setToast({ isOpen: true, message: 'Activo actualizado exitosamente', type: 'success' });
        setTimeout(() => navigate('/activos/listado'), 1200);
      } else {
        setToast({ isOpen: true, message: response.message || 'Error al actualizar', type: 'error' });
      }
    } catch {
      setToast({ isOpen: true, message: 'Error al actualizar el activo', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div className="p-6">
        <div className="max-w-4xl mx-auto text-gray-600">Cargando activo…</div>
      </div>
    );
  }

  if (!activo) {
    return (
      <div className="p-6">
        <div className="max-w-4xl mx-auto">
          <p className="text-red-600 mb-4">No se encontró el activo.</p>
          <Link to="/activos/listado" className="text-teal-600 hover:underline">Volver al listado</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar activo</h1>
          <p className="text-gray-600 mt-1">{activo.code} — {activo.name}</p>
        </div>

        <nav className="text-sm text-gray-600 mb-6">
          <Link to="/activos/listado" className="hover:text-teal-600">← Volver al listado</Link>
        </nav>

        <ActivoForm initialData={activo} onSubmit={handleSubmit} loading={loading} submitLabel="Guardar cambios" />
      </div>

      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, isOpen: false })}
      />
    </div>
  );
};

export default EditActivo;
